import './styles/breadcrumb/app.scss';

// start the Stimulus application
import './bootstrap';

// this "modifies" the jquery module: adding behavior to it
// the bootstrap module doesn't export/return anything
require('bootstrap');